module.exports = __webpack_public_path__ + "static/communities-f892385ad45d6f79a678da696c037e07.svg";